import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";
import { showToast } from "./ToastSlice";

export const fetchCallingDeviceToken = createAsyncThunk(
  "callingDeviceToken/fetchToken",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.get("/integrations/token");
console.log(response.data,"callingdevicetoken");

      return response.data.access_token;
    } catch (error) {
      dispatch(
        showToast({
          message: error.response?.data?.message || "Failed to fetch contacts",
          type: "error",
        })
      );
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch token"
      );
    }
  }
);

const callingDeviceTokenSlice = createSlice({
  name: "callingDeviceToken",
  initialState: {
    callingDeviceToken: null,
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchCallingDeviceToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCallingDeviceToken.fulfilled, (state, action) => {
        state.loading = false;
        state.callingDeviceToken = action.payload;
      })
      .addCase(fetchCallingDeviceToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default callingDeviceTokenSlice.reducer;
